
import axios from "axios";

import tooltipsInit from "../components/tooltips.js";
import animationInit from "../components/animation.js";

document.addEventListener("DOMContentLoaded", () => {
    const lang = document.querySelector('html').getAttribute('lang');
    // init Tooltips
    tooltipsInit();


    // init Cart
    const { fadeIn, fadeOut } = animationInit();


    // save PDF
    const savePDFBtn = document.querySelectorAll(".button--save");
    savePDFBtn.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            window.location.href = '/'+lang+'/save-pdf';
            console.log("Save PDF");
        });
    });


    // print
    const printBtn = document.querySelectorAll(".button--print");
    printBtn.forEach(btn => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = '/'+lang+'/print-pdf';
            document.body.appendChild(iframe);
            window.addEventListener('afterprint', () => {
                document.body.removeChild(iframe);
            }, { once: true });
            iframe.onload = () => {
                iframe.contentWindow.print();
            };
        });
    });

    // Open/Close popup
    const openFormBtn = document.querySelector(".create__order");
    const popupBlockElm = document.querySelector(".popup-block");
    const popupBlockWrapElm = document.querySelector(".popup-block-wrap");
    const popupBlockInnerElm = document.querySelector(".popup-block-inner");

    const popupCloseBtn = document.querySelector(".popup-close");

    if(openFormBtn) {
        openFormBtn.addEventListener("click", (e) => {
            e.preventDefault();
            // const form = document.querySelector(".order-form");
            fadeIn(popupBlockElm);
        });
    }

    [popupBlockWrapElm, popupCloseBtn].forEach((item) => {
        item.addEventListener("click", (e) => {
            e.preventDefault();
            fadeOut(popupBlockElm);
        });
    });

    popupBlockInnerElm.addEventListener("click", (e) => {
        e.stopPropagation();
    });

    // Order form
    const orderForm = document.querySelector(".order_form");


    if(orderForm) {
        orderForm.addEventListener("submit", (e) => {
            e.preventDefault();
            // console.log("Order form submit");
            axios
                .post('/'+lang+'/new-order', {
                    name: document.querySelector('[name="name"]').value,
                    phone: document.querySelector('[name="phone"]').value,
                    email: document.querySelector('[name="email"]').value,

                })
                .catch((error) => {
                    if (error.response.status === 422) {
                        document.querySelectorAll('.order_form .error').forEach(function(element) {
                            element.classList.remove('error');
                        });
                        const errors = error.response.data.errors;
                        Object.keys(errors).forEach(fieldName => {
                            const inputField = document.querySelector(`[name="${fieldName}"]`);
                            const parentElement = inputField.parentElement;
                            parentElement.classList.add('error');
                        });
                    }
                })
                .then((response) => {
                    console.log(response);
                    if (response?.data?.status) {
                        window.location.href = '/'+lang+'/success';
                    }
                })

        });
    }


    let inputValueChanged = false;

    function updateInputValue(tileSurface, productId) {
        document.querySelector(`.input-quantity[data-product-id="${productId}"]`).value = tileSurface;
    }

    function calculatePriceAndWeight(productId, module, price) {
        const inputValue = document.querySelector(`.input-quantity[data-product-id="${productId}"]`).value;

        axios.post('/calculate-cart', {
            itemId: productId,
            quantity: inputValue,
            module: module,
            box_kg: document.querySelector('.total_weight').dataset.boxKg
        })
            .then(function (response) {
                document.querySelector('.sum span').textContent = response.data.response.total;
                document.querySelector('.total-weight').textContent = response.data.response.weight;
                document.querySelector('.total-pack').textContent = response.data.response.packs;

                // Обновляем данные для товаров на странице
                const updatedDetails = response.data.response.details;

                updatedDetails.forEach((item, index) => {
                    const qtyInput = document.querySelectorAll(`.input-quantity`)[index];
                    const totalSpan = document.querySelectorAll(`.list_item-total span`)[index];

                    if (qtyInput) {
                        qtyInput.value = item.qty;
                    }

                    if (totalSpan) {
                        totalSpan.textContent = item.total_price;
                    }
                });
            })
            .catch(function (error) {
                console.error('error', error);
            });
    }

    document.querySelectorAll('.input-quantity').forEach(function(inputElement) {
        const productId = inputElement.dataset.productId;
        const module = inputElement.dataset.module;
        const price = inputElement.dataset.price;

        inputElement.addEventListener('input', function() {
            inputValueChanged = true;
        });

        inputElement.addEventListener('change', function() {
            if (inputValueChanged) {
                calculatePriceAndWeight(productId, module, price);
                inputValueChanged = false;
            }
        });

        inputElement.addEventListener('keydown', function(event) {
            if (event.key === 'Enter' && inputValueChanged) {
                calculatePriceAndWeight(productId, module, price);
                inputValueChanged = false;
            }
        });
    });

    document.addEventListener('click', function(event) {
        const targetInput = event.target.closest('.input-quantity');
        if (!targetInput) {
            const productId = document.querySelector('.input-quantity').dataset.productId;
            if (inputValueChanged) {
                calculatePriceAndWeight(productId);
                inputValueChanged = false;
            }
        }
    });




    const removeItemBtns = document.querySelectorAll(".list_item-delete .delete");
    removeItemBtns.forEach((btn) => {
        btn.addEventListener("click", (e) => {
            e.preventDefault();
            const itemId = e.target.dataset.param;
            const module = e.target.dataset.module;
            axios.post(`/remove-item`, {
                itemId: itemId,
                module: module
            })
                .then(response => {
                    document.querySelector('.sum span').textContent = response.data.response.total;
                    document.querySelector('.total-weight').textContent = response.data.response.weight;
                    document.querySelector('.total-pack').textContent = response.data.response.packs;

                    if (response.data.response.count === 0) {
                        const headerShoppingCartElm = document.querySelector('.header__shopping_cart');
                        headerShoppingCartElm.classList.remove('has-items');
                        document.querySelectorAll(".cart__actions, .cart__list_header, .cart__body, .cart__footer").forEach(el => {
                            el.classList.add('d-none');
                        });
                        document.querySelector(".wish-empty").classList.remove('d-none');
                    }

                    document.querySelectorAll("span[data-param='" + itemId + "']").forEach(span => {
                        var parent = span.parentElement.parentElement;
                        parent.style.transition = "opacity 0.3s ease";
                        parent.style.opacity = 0;
                        setTimeout(() => parent.parentNode.removeChild(parent), 300);

                        if (parent.parentNode.querySelectorAll('.cart__list_item').length - 1 === 0) {
                            parent.parentNode.parentNode.parentNode.classList.add('d-none');
                        }
                    });

                })
                .catch(error => {
                    console.error('Error removing item from cart:', error);
                });
        });
    });





});
